import Icon from '../components/Icon.vue'

Icon.register({
  sitemap: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M128 352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h96zM104 272v48h-48v-57.6c0-21.2 17.2-38.4 38.4-38.4h201.6v-64h-40c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-40v64h201.6c21.2 0 38.4 17.2 38.4 38.4v57.6h-48v-48h-192v48h-48v-48h-192zM368 352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h96zM608 352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sitemap.js
// module id = 1894
// module chunks = 0